export default function() {
	return {
		init: false,
		loading: false,


		// listings
		listingViewsSum: 0,
		listingViewsChart: [],
		phoneCallClicks: 0,
		chatLeadsSum: 0,
		chatLeadsChart: [],
		mailLeadsSum: 0,
		mailLeadsChart: [],

		// vehicle
		vehicleCountCurrent: 0,
		vehicleCountChart: [],
		vehicleErrorSum: 0,
		vehicleErrorChart: {
			series: [],
			labels: [],
		},

		// leads
		leadMakeChart: [],
		pricePieChart: {
			series: [],
			labels: [],
		},

		// filter
		maxDate: null,
		filter: {
			from: null,
			to: null,
		},
	};
}
